"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTO_SCIENTIFIC_NOTATION_FORMAT = exports.WORKSHEET_DEFAULT_FORMAT = exports.SCIENTIFIC_NOTATION_FORMAT = void 0;
exports.SCIENTIFIC_NOTATION_FORMAT = '0.00e+0';
exports.WORKSHEET_DEFAULT_FORMAT = '0.[000]';
exports.AUTO_SCIENTIFIC_NOTATION_FORMAT = 'auto-scientific';
